import {AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {StorageService} from '../../../../Services/storage.service';
import {DataExportService} from '../../../../Services/dataExport.service';
import {Title} from '@angular/platform-browser';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {FilterPipe} from 'ngx-filter-pipe';
import {AppConfigService} from '../../../../Services/app-config.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {Router} from '@angular/router';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-entity-history-report',
  templateUrl: './entity-history-report.component.html',
  styleUrls: ['./entity-history-report.component.css'],
  standalone: false
})
export class EntityHistoryReportComponent implements OnInit, AfterViewInit, AfterViewChecked {
  // Email modal integration
  reportDataToSendInEmail: EmailModel = new EmailModel();
  // Standard report header button configuration
  buttonConfig: any = {
    reportFormat: false,
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };
  @ViewChild('excelExportRecentItems', {static: false}) excelExportRecentItems!: ElementRef;
  @ViewChild('excelExportTopItems', {static: false}) excelExportTopItems!: ElementRef;
  @ViewChild('excelExportReceivableInvoices', {static: false}) excelExportReceivableInvoices!: ElementRef;
  @ViewChild('excelExportReceivablePayments', {static: false}) excelExportReceivablePayments!: ElementRef;
  @ViewChild('excelExportPayableInvoices', {static: false}) excelExportPayableInvoices!: ElementRef;
  @ViewChild('excelExportPayablePayments', {static: false}) excelExportPayablePayments!: ElementRef;

  private rptName: string;
  isLoaded = false;

  vm: any = {
    ToEmailError: false,
    showSpecificDates: false,
    company: [],
    currency: [],
    email: {
      fromemail: this.appConfigService.SysEmailAddress,
    },
    request: {
      fromDate: null,
      toDate: null,
      entity_id: null,
      report_type_id: 1,
    },
    report: [],
    Preferences: [],
    permissions: [],
    fromDateSelect: [],
    toDateSelect: [],
    monthCount: 0,
    dateError: false,
    buttonsDisabled: false,
    showEmail: true,
    exportToExcel: true,
    showFilters: false,
    entity: [],
    entityName: [],
    entityFilter: { name: '' },
    startEntity: 0,
  };

  constructor(
    public localStorage: StorageService,
    public tableDataService: DataService,
    private titleService: Title,
    public appConfigService: AppConfigService,
    public dateFilter: DateFilterService,
    public notification: BsToastService,
    public excelExporter: DataExportService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private reportPrint: ReportPrintService
  ) {
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    // this.vm.email.toemail = this.localStorage.StorageGet('ToEmail', '');
  }

  ngOnInit() {
    if (!this.vm.request.toDate && !this.vm.request.fromDate) {
      this.newDateFilter(new Date(), new Date());
      const range = this.dateFilter.GetDefaultDateRange(
        'span',
        this.vm.fromDateSelect,
        this.vm.toDateSelect,
        90
      );
      this.vm.request.toDate = range.toDate;
      this.vm.request.fromDate = range.fromDate;
    }
    this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);
    this.FilterOptionsInit();
    this.rptName = $localize`:Entity History Report @@entityHistoryReport:Entity History Report`;
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
  }

  setEmailData() {
    const emailDocObj = {} as EmailModel;

    // Determine report name based on selected report type
    let reportName = 'Entity History';
    switch (this.vm?.request?.report_type_id) {
      case 1:
        reportName = 'Entity History Recent Items';
        break;
      case 2:
        reportName = 'Entity History Top Items';
        break;
      case 3:
        reportName = 'Entity History Receivable Invoices';
        break;
      case 4:
        reportName = 'Entity History Receivable Payments';
        break;
      case 5:
        reportName = 'Entity History Payable Invoices';
        break;
      case 6:
        reportName = 'Entity History Payable Payments';
        break;
    }

    // printing options
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';

    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Build unified HTML (same as print). Fallback to raw export HTML if needed.
    try {
      this.changeDetectorRef.detectChanges();
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      // Fallback to raw per-type export HTML
      try {
        let tempPdfHtml = '';
        if (this.objectKeys(this.vm.report).length > 0) {
          if (this.vm.request.report_type_id == 1 && this.excelExportRecentItems) {
            tempPdfHtml = this.excelExportRecentItems.nativeElement.outerHTML || this.excelExportRecentItems.nativeElement.innerHTML || '';
          } else if (this.vm.request.report_type_id == 2 && this.excelExportTopItems) {
            tempPdfHtml = this.excelExportTopItems.nativeElement.outerHTML || this.excelExportTopItems.nativeElement.innerHTML || '';
          } else if (this.vm.request.report_type_id == 3 && this.excelExportReceivableInvoices) {
            tempPdfHtml = this.excelExportReceivableInvoices.nativeElement.outerHTML || this.excelExportReceivableInvoices.nativeElement.innerHTML || '';
          } else if (this.vm.request.report_type_id == 4 && this.excelExportReceivablePayments) {
            tempPdfHtml = this.excelExportReceivablePayments.nativeElement.outerHTML || this.excelExportReceivablePayments.nativeElement.innerHTML || '';
          } else if (this.vm.request.report_type_id == 5 && this.excelExportPayableInvoices) {
            tempPdfHtml = this.excelExportPayableInvoices.nativeElement.outerHTML || this.excelExportPayableInvoices.nativeElement.innerHTML || '';
          } else if (this.vm.request.report_type_id == 6 && this.excelExportPayablePayments) {
            tempPdfHtml = this.excelExportPayablePayments.nativeElement.outerHTML || this.excelExportPayablePayments.nativeElement.innerHTML || '';
          }
        }
        emailDocObj.pdfHtml = tempPdfHtml;
      } catch {
        emailDocObj.pdfHtml = '';
      }
    }
    emailDocObj.activity_message = reportName;

    // deterministic file name
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const safe = reportName.replace(/\s+/g, '_');
    emailDocObj.FileName = safe + '_' + yyyy + mm + dd + '.pdf';

    this.reportDataToSendInEmail = emailDocObj;

    // Open shared Send Email modal on next tick to allow bindings to propagate
    setTimeout(() => {
      const element = document.getElementById('sendEmailModal') as HTMLElement;
      if (element) {
        const emailModal = new Modal(element);
        emailModal.show();
      }
    }, 0);
  }

  // Print the report content using a generated HTML document (do not use PrintService)
  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Entity History print failed', e);
      this.notification?.showWarningToast?.('Unable to print Entity History Report');
    }
  }

  // Build a self-contained HTML for printing/emailing the current report
  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = (this.excelExportRecentItems?.nativeElement?.outerHTML || this.excelExportTopItems?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: from && to ? `${from} to ${to}` : (from || to)});
    }
    return this.reportPrint.buildHtml({title: 'Entity History Report', contentHtml: content, meta, orientation: 'landscape'});
  }

  // Utility to print HTML in a hidden iframe and clean up afterward
  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  private escapeHtml(text: string): string {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  loadEmailReportValues() {
    // set email data
    this.changeDetectorRef.detectChanges();
    let tempPdfHtml = '';
    let subject = '';
    if (this.objectKeys(this.vm.report).length > 0) {
      if (this.vm.request.report_type_id == 1 && this.excelExportRecentItems != undefined) {
        tempPdfHtml = this.excelExportRecentItems.nativeElement.innerHTML;
        subject = $localize`:Entity History Recent Items @@entityHistoryRecentItems:Entity History Recent Items`;
      } else if (this.vm.request.report_type_id == 2 && this.excelExportTopItems != undefined) {
        tempPdfHtml = this.excelExportTopItems.nativeElement.innerHTML;
        subject = $localize`:Entity History Top Items @@entityHistoryTopItems:Entity History Top Items`;
      } else if (this.vm.request.report_type_id == 3 && this.excelExportReceivableInvoices != undefined) {
        tempPdfHtml = this.excelExportReceivableInvoices.nativeElement.innerHTML;
        subject = $localize`:Entity History Receivable Invoices @@entityHistoryReceivableInvoices:Entity History Receivable Invoices`;
      } else if (this.vm.request.report_type_id == 4 && this.excelExportReceivablePayments != undefined) {
        tempPdfHtml = this.excelExportReceivablePayments.nativeElement.innerHTML;
        subject = $localize`:Entity History Receivable Payments @@entityHistoryReceivablePayments:Entity History Receivable Payments`;
      } else if (this.vm.request.report_type_id == 5 && this.excelExportPayableInvoices != undefined) {
        tempPdfHtml = this.excelExportPayableInvoices.nativeElement.innerHTML;
        subject = $localize`:Entity History Payable Invoices @@entityHistoryPayableInvoices:Entity History Payable Invoices`;
      } else if (this.vm.request.report_type_id == 6 && this.excelExportPayableInvoices != undefined) {
        tempPdfHtml = this.excelExportPayablePayments.nativeElement.innerHTML;
        subject = $localize`:Entity History Payable Payments @@entityHistoryPayablePayments:Entity History Payable Payments`;
      }
    }
  }

  ngAfterViewChecked() {}

  newDateFilter(toDate, fromDate) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
  }

  FilterOptionsInit() {
    // loads the value the modal entity select uses
    this.tableDataService
      .getData('entity?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.entity = result.Data;
        for (const [x, value] of Object.entries(this.vm.entity)) {
          this.vm.entityName.push({ name: this.vm.entity[x].name });
        }
      });

    this.vm.report_types = [
      { id: 1, name: 'Recent Items' },
      { id: 2, name: 'Top Items' },
      { id: 3, name: 'Receivable Invoices' },
      { id: 4, name: 'Receivable Payments' },
      { id: 5, name: 'Payable Invoices' },
      { id: 6, name: 'Payable Payments' },
    ];
    // this.vm.request.report_type_id = 1;
  }

  exportToExcel() {
    if (this.vm.request.report_type_id == 1 && this.excelExportRecentItems) {
      this.excelExporter.exportToExcel(this.excelExportRecentItems, this.rptName + '.xlsx');
    } else if (this.vm.request.report_type_id == 2 && this.excelExportTopItems) {
      this.excelExporter.exportToExcel(this.excelExportTopItems, this.rptName + '.xlsx');
    } else if (this.vm.request.report_type_id == 3 && this.excelExportReceivableInvoices) {
      this.excelExporter.exportToExcel(this.excelExportReceivableInvoices, this.rptName + '.xlsx');
    } else if (this.vm.request.report_type_id == 4 && this.excelExportReceivablePayments) {
      this.excelExporter.exportToExcel(this.excelExportReceivablePayments, this.rptName + '.xlsx');
    } else if (this.vm.request.report_type_id == 5 && this.excelExportPayableInvoices) {
      this.excelExporter.exportToExcel(this.excelExportPayableInvoices, this.rptName + '.xlsx');
    } else if (this.vm.request.report_type_id == 6 && this.excelExportPayablePayments) {
      this.excelExporter.exportToExcel(this.excelExportPayablePayments, this.rptName + '.xlsx');
    }
  }

  validateEmpty(value) {
    let returnValue = '-';
    if (value != null) {
      returnValue = value.trim();
      if (value != '') {
        returnValue = value;
      }
    }
    return returnValue;
  }

  update() {
    const tempToDate: any = new Date(this.vm.request.toDate);
    const tempFromDate: any = new Date(this.vm.request.fromDate);
    if (tempFromDate > tempToDate) {
      this.vm.dateError = true;
      this.notification.showWarningToast(
        $localize`:The "To-Date" must be greater than the "From-Date". @@theToDatemustbegreaterthantheFromDate:The "To-Date" must be greater than the "From-Date".`
      );
    } else if (!this.vm.request.fromDate || !this.vm.request.toDate) {
      this.vm.dateError = true;
      this.notification.showWarningToast(
        $localize`:You must select from and to dates. @@youmustselectfromandtodates:You must select from and to dates.`
      );
    } else {
      if (!this.vm.request.entity_id) {
        this.notification.showWarningToast(
          $localize`:Entity filter required! @@entityfilterrequired:Entity filter required!`
        );
        return;
      }

      this.vm.monthCount = (tempToDate - tempFromDate) / 86400 / 30 / 1000;
      this.vm.buttonsDisabled = true;
      this.vm.dateError = false;
      this.isLoaded = false;
      this.tableDataService.getData('entity_history/' + this.vm.request.entity_id,
        '?fromDate=' + new Date(this.vm.request.fromDate).toISOString() + '&toDate=' + new Date(this.vm.request.toDate).toISOString())
        .subscribe((result) => {
          this.vm.report = result;
          this.vm.buttonsDisabled = false;
          this.isLoaded = true;
          // console.log(result);
          // this.localStorage.StorageSet('fromDate', this.vm.request.fromDate);
          // this.localStorage.StorageSet('toDate', this.vm.request.toDate);
          if (result) {
            // this.loadEmailReportValues();
          } else {
            this.notification.showWarningToast('No data for the selected dates and entity.');
          }
        });
    }
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  close() {
    this.router.navigateByUrl('/home').then();
  }

  clear() {
    this.vm.entityFilter.name = '';
    this.vm.report = [];
    this.vm.request = {
      toDate: null,
      fromDate: null,
      entity_id: null,
    };
  }

  // Legacy direct window.print() removed in favor of printReport()

  objectKeys(obj) {
    if (obj != null) {
      return Object.keys(obj);
    }
    return { length: 0 };
  }

  updateEntity() {
    this.vm.buttonsDisabled = true;
    this.localStorage.StorageSet('entity', '');
    this.tableDataService
      .getData('entity', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.entity = result.Data;
      });
  }

  selectEntityModal(entityName) {
    this.vm.request.entity_id = '';
    if (this.vm.request.entity_id == '' || 1 === 1) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        if (this.vm.entity[y].name == entityName) {
          this.vm.entityInput = entityName;
          this.vm.request.entity_id = this.vm.entity[y].id;
          this.vm.report = [];
          break;
        }
      }
    }
  }

  testEntity() {
    const entityIdStart = this.vm.request.entity_id;
    if (!this.vm.entityInput || this.vm.entityInput == '' || this.vm.entityInput == null) {
      this.vm.request.entity_id = '';
    } else {
      if (this.FilterObject(this.vm.entity, { name: this.vm.entityInput }).length > 0) {
        const entityId = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].id;
        const entityName = this.FilterObject(this.vm.entity, { name: this.vm.entityInput }, true)[0].name;
        if (entityId != '' || entityId != null) {
          this.vm.request.entity_id = entityId;
          this.vm.entityInput = entityName;
        } else {
          this.vm.request.entity_id = '';
        }
      } else {
        this.vm.request.entity_id = '';
      }
    }
    if (entityIdStart != this.vm.request.entity_id) {
      this.vm.report = [];
    }
  }
}
